import { formatDisplayPrice } from '../../../../../../../utils/math/formatDisplayPrice';
import { timeUnitMap } from '../../../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setupFilters/FTFCBoxes';

export function parseCandleTriggerNotificationDetails(notification) {
  const setupTemplate = notification.statusDetails.setupTemplate;
  const setupString =
    'Candle Trigger-' +
    setupTemplate.candleDuration +
    timeUnitMap[setupTemplate.timeUnit];

  return {
    tactic: setupString,
    price: formatDisplayPrice(notification.statusDetails.triggerPrice),
  };

}

// {
//   "messageType": "alertNotification",
//   "notificationId": 1643916005185,
//   "notificationType": "TRADE_PLAN_ALERT",
//   "typeDetails": {
//       "watchlistName": "test3",
//       "id": 1643929332209
//   },
//   "status": "SETUP_TRIGGERED",
//   "statusDetails": {
//       "setupName": "CANDLE_TRIGGER",
//       "triggerPrice": 101,
//       "tradeDirection": "LONG",
//       "symbol": "TSLA",
//       "setupTemplate": {
//           "candleDuration": 1,
//           "timeUnit": "DAYS"
//       }
//   },
//   "date": "2022-02-03T18:02:24.467-0500",
//   "timestamp": "1643929344467"
// }
